import { CheckNotes, InspectionCase } from '../inspection-cases';
import { Inspection } from '../inspection.dto';
import { GasActivationTest } from './gas-activation-test.dto';
import { GasExtinguishingSystem } from './gas-extinguishing-system.dto';
import { GasIndoorTest } from './gas-indoor-test.dto';

export class GasSystemAreaDto extends InspectionCase {
  gasExtinguishingSystem?: GasExtinguishingSystem;
  gasIndoorTest?: GasIndoorTest;
  gasActivationTest?: GasActivationTest;
}

export class GasSystemArea extends GasSystemAreaDto implements Inspection {
  constructor(
    data: GasSystemAreaDto = {
      title: '',
      isApplicable: true
    }
  ) {
    super(data);

    this.gasExtinguishingSystem = new GasExtinguishingSystem(
      data.gasExtinguishingSystem
    );
    this.gasIndoorTest = new GasIndoorTest(data.gasIndoorTest);
    this.gasActivationTest = new GasActivationTest(data.gasActivationTest);
  }

  setInspectionStatus(): void {
    this.gasExtinguishingSystem.setInspectionStatus();
    this.gasIndoorTest.setInspectionStatus();
    this.gasActivationTest.setInspectionStatus();

    this.isPassed =
      this.gasExtinguishingSystem.isPassed &&
      this.gasIndoorTest.isPassed &&
      this.gasActivationTest.isPassed;
  }

  getNotes?(): CheckNotes[] {
    if (!this.isApplicable) {
      return [];
    }
    return [
      ...this.gasExtinguishingSystem.getNotes(),
      ...this.gasIndoorTest.getNotes(),
      ...this.gasActivationTest.getNotes()
    ];
  }

  setAsApplicable?(): void {
    this.isApplicable = true;
    this.gasExtinguishingSystem.setAsApplicable();
    this.gasIndoorTest.setAsApplicable();
    this.gasActivationTest.setAsApplicable();
  }
}
